import { Button, Stack, Typography } from "@mui/material";
import { ReservationState } from "../../util/useReservationState";

export default function FormError({ state }: { state: ReservationState }) {
  return (
    <Stack mt={2} gap={1}>
      <Typography textAlign="center">エラーが発生しました。最初からやり直してください。</Typography>
      <Button variant="outlined" onClick={state.reset}>
        トップへ
      </Button>
    </Stack>
  );
}
